<template>
  <div class="container">
    <router-view />
  </div>
</template>
<script>
import {} from "@/api/index";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["lnbVisible", "gnbVisible", "isLogin"]),
  },
  created() {},
  destroyed() {},

  methods: {},
};
</script>
